import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-moto-personnelle',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-moto-personnelle.component.html',
  styleUrls: ['./assurance-moto-personnelle.component.scss']
})
export class AssuranceMotoPersonnelleComponent {
  title = 'Assurance Moto Personnelle';
  subtitle = '';
  phoneNumber = '01 43 27 12 43';
  heroImage = 'assets/static_pages_images/MotoPersonnelle.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Moto', link: undefined }
  ];

  prevPage = { title: 'Assurance Habitation',
    link: '/assurance-multirisque-habitation'
  };

  nextPage = { title: 'Assurance Auto Temporaire',
    link: '/assurance-auto-temporaire'
  };

  // Partners logos for carousel
  partners = [
    { name: 'Mutuelle des Motards AMV', logo: 'assets/logos/mutuelle_motards.png' },
    { name: 'April', logo: 'assets/logos/april.png' },
    { name: 'FMA', logo: 'assets/logos/fma.png' },
    { name: 'Swiss Life', logo: 'assets/logos/SWISSLIFE.PNG' },
    { name: 'Liberty', logo: 'assets/logos/liberty.png' },
    { name: 'Novelia', logo: 'assets/logos/novelia.png' },
    { name: 'Zephir', logo: 'assets/logos/zephir.png' },
    { name: 'Netvox', logo: 'assets/logos/netvox.png' },
  ];

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}

